import React from 'react';
import { fromPairs, map, get, isEqual } from 'lodash';
import classnames from 'classnames';

// local Dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { Form } from 'modules/form';
import { button as Button } from 'modules/button';
import { entityInfoCells as EntityInfoCells } from 'ui/views/widgets/entityInfoCells';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { claimToDo as claimToDo } from 'ui/views/claimToDo';
 *
 * // render
 * <claimToDo propName='propValue'/>
 */
export const claimToDo = ( props ) => {

    // get the static fields for different category trypes
    // let coloumns = [];

    // if( ! isUndefined( get( props, 'secondaryType', undefined ) ) ) {

    //     const _data = find( props.dynamicFields, { value: `${ props.secondaryType }` } );
    //     if( _data && 0 !== size( _data.staticFields ) ) {
    //         forEach( _data.staticFields, field => {
    //             const data = find( props.primaryColumns, { name: field } );
    //             coloumns = [ ...coloumns, data ];
    //         } );
    //     }
    // }

    return (
		<div className='ui-claim-reversal'>
			<div className='ui-claim-reversal__header'>

				{ /* title for the modal */ }
				<div className='ui-claim-reversal__header__title'>
					{ getLabel( props.title ) }
				</div>

				{ /* close button */ }
				<div
					className='ui-error-overlay__head__close'
					onClick={ () => props.closeOverlay() }
				>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>
			</div>
			<div className='ui-claim-reversal__body'>

                <div className='ui-claim-reversal__body__primary'>
                    <EntityInfoCells
                        items={props.primaryColumns}
                        values={props.state}
                        className='ui-claim-reversal__body__primary__cell'
                    />
                </div>
               
				<Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.state.values } // default values
                    isValid={ false }
                    mode='form'

                    // key={ props.secondaryType }
                    // onChangeCallBack={ props.onChangeCallBack }
                    // updatFieldsOnChange={ true }
                    onSubmit={ ( { values, isValid } ) => {
                        if( isValid ) {
                            props.onFormSubmit( values );
                        }
                    } }
                >
                    { ( { fields, values, /*isValid,*/ errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-claim-reversal__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {

                                    // if( get( field, 'config.hide' ) ) {
                                    //     return null;
                                    // }

                                    const fieldClassName = classnames( 'ui-claim-reversal__body__form__field', `ui-claim-reversal__body__form__${field.name}` );
   
                                    return (
                                        <field.view
                                            className={ fieldClassName }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props.options, field.options ) }
                                            allowFilter={ 'state' === field.name }
                                            config={ field.config }
                                            subFields={ props.subFields }
                                            optionsList={ props.options }

                                            // subFields={ props.subFields }
                                            // mask={ field.mask }
                                        />
                                    );
                                } ) }
                                {/* button actions */}
                                <div className='ui-claim-reversal__body__form__actions'>
                                    { map( props.actions, action => {
                                        return (
                                            <Button
                                                key={ action.name }
                                                id= { action.name }
                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }

                                                // disabled={ 'cancel' !== action.name ? !isValid : false }
                                                { ...action }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-claim-reversal__body__form__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ?  () => {

                                                    // popover.close();
                                                    props.onCancelClick();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>
                            </form>
                        );
                    } }
                </Form>
            </div>
		</div>
	);
};

// set display name
claimToDo.displayName = 'claimToDo';

// set default props
claimToDo.defaultProps = {};

// prop types
claimToDo.propTypes = {};
